import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-lg border border-lightGray30 text-left",
  "data-testid": "ds-attendance-previous-sheets"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "text-base font-bold text-textPrimary" }
const _hoisted_4 = {
  key: 0,
  class: "border-t border-lightGray30 divide-y divide-lightGray30"
}
const _hoisted_5 = { class: "flex flex-col min-w-0" }
const _hoisted_6 = { class: "text-sm font-medium text-textPrimary truncate" }
const _hoisted_7 = { class: "text-xs text-neutralLight" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "rounded bg-negative/10 text-negative px-2 py-[2px] text-[11px] font-bold uppercase" }, " Recusada ", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-textPrimary"
}

import { ref } from 'vue'
import { mdiChevronDown, mdiChevronUp, mdiFileOutline } from '@mdi/js'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import Network from '@/Network'
import { useErrorToast } from '@/composables/useErrorToast'
import { REJECTION_REASON_LABELS, RejectionReason } from '@/constants/ds-attendance.constants'
import type { DSAttendancePreviousSheet } from '@/Network/Types/Responses/DsAttendancePolicyResponses'

/**
 * rejected-sheet-resubmission (G1, CA6): folhas recusadas, abaixo do visualizador.
 * "Abrir" usa a rota de anexo do registro (marca d'água por visualizador, anti-IDOR):
 * a folha recusada continua ligada ao registro, só deixou de ser a principal.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendancePreviousSheets',
  props: {
    containerId: {},
    sheets: {}
  },
  setup(__props: any) {

const props = __props;



const { notifyError } = useErrorToast()
const isOpen = ref(true)

const formatDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })

const reasonLabel = (reason: string): string =>
  REJECTION_REASON_LABELS[reason as RejectionReason] ?? reason

async function openSheet(evidenceId: number): Promise<void> {
  try {
    const blob = await Network.dsAttendance.getAttachmentFile(props.containerId, evidenceId)
    window.open(URL.createObjectURL(blob), '_blank')
  } catch (error) {
    notifyError(error, 'Não foi possível abrir a folha anterior.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.sheets && _ctx.sheets.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "w-full flex items-center justify-between px-4 py-3",
          "aria-expanded": isOpen.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
        }, [
          _createElementVNode("span", _hoisted_3, "Folhas anteriores (" + _toDisplayString(_ctx.sheets.length) + ")", 1),
          _createVNode(_component_v_icon, {
            icon: isOpen.value ? _unref(mdiChevronUp) : _unref(mdiChevronDown),
            size: "22"
          }, null, 8, ["icon"])
        ], 8, _hoisted_2),
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheets, (sheet) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: sheet.evidenceId,
                  "data-testid": "ds-attendance-previous-sheet",
                  class: "flex flex-wrap items-center gap-3 px-4 py-3"
                }, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiFileOutline),
                    size: "28",
                    class: "text-neutralLight"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(sheet.fileName || 'Folha de monitoramento'), 1),
                    _createElementVNode("span", _hoisted_7, [
                      (sheet.sentAt)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Enviada em " + _toDisplayString(formatDate(sheet.sentAt)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (sheet.rejectedAt)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" · Recusada em " + _toDisplayString(formatDate(sheet.rejectedAt)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_8,
                  (sheet.rejectionReason)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Motivo: " + _toDisplayString(reasonLabel(sheet.rejectionReason)), 1))
                    : _createCommentVNode("", true),
                  _createVNode(OutlineButton, {
                    class: "ml-auto",
                    text: "Abrir",
                    width: "80px",
                    height: "32px",
                    "data-testid": `ds-attendance-previous-sheet-open-${sheet.evidenceId}`,
                    onClick: ($event: any) => (openSheet(sheet.evidenceId))
                  }, null, 8, ["data-testid", "onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})